import { ref, computed, getCurrentInstance, onMounted, nextTick } from 'vue';
import { useCommonData } from '@rebuild/hooks/useCommonData';

export function useFloating() {
	const vm = getCurrentInstance();
	const moduleId = computed(() => vm.proxy.$route.params.moduleId);

	const showFloating = computed(() => {
		const { f = '' } = vm.proxy.$route.query;
		return f !== 'PC';
	});

	const { isCardTmpl, isFlowTmpl } = useCommonData();
	const inHomeView = computed(() => vm.proxy.$route.name.includes('home'));
	const floatingOptions = computed(() => {
		if (inHomeView.value) {
			if (isCardTmpl.value) return ['lang', 'survey', 'feedback', 'subscription'];
			if (isFlowTmpl.value) return ['lang'];
		}

		return ['lang'];
	});

	onMounted(() => {
		nextTick(() => {
			initFloating();
		});
	});

	const floating = ref(null);
	const initFloating = () => {
		const f = floating.value;
		const fc = f?.child;
		if (fc) {
			const bottom = 80;
			fc.init(bottom);
		}
	};

	return {
		showFloating,
		floatingOptions,
		floating
	};
}
